import React from "react";
import { Link, withRouter } from "react-router-dom";
import { DashboardTile } from "./DashboardTile";
import * as msgs from "../../constants/textConstants";
import PharmacyAllTile from "../pharmacy/PharmacyAllTile";
import LettersTile from "./LettersTile";
import CareCompanionTile from "../carecoach/CareCompanionTile";
import HealthPlanTile from "../healthplan/HealthPlanTile";
import Covid19Tile from "../covid19vaccine/Covid19Tile";

import * as d from "../../reducers/domainReducer";
import { connect } from "react-redux";
import AAUserTile from "../connectedcare/AAUserTile";

const ResourceTile = (props) => {

    const { isProxyUser, hasPharmacyFeature, serverData, isMobile,
        hasMyChartLogin, isActiveFeature_InsuranceModule, bffDashboardData,
        isShowAllUsers, currentMyChartUser, disableMyChartTiles, enableAALElements,
        swhpDown, aalDown, hasHealthPlanLogin, hasFirstCare } = props;

    const showCareCompanion = isShowAllUsers ? bffDashboardData?.data?.showCareCompanion : bffDashboardData?.data?.currentUser?.careCompanion?.isCareCompanion;

    return (<>
        <DashboardTile
            className="resource-tile"
            noBorder={isMobile ? true : false}
        >
            <div className="col-12 resource-tile-container">
                <div className="row">
                    <Covid19Tile                      
                        disabled={disableMyChartTiles}
                    />
                    <LettersTile
                        currentMyChartUser={currentMyChartUser}
                        dashboardData={bffDashboardData}
                        disabled={disableMyChartTiles}
                        isProxyUser={isProxyUser}
                        isShowAllUsers={isShowAllUsers}
                    />

                    {showCareCompanion && <CareCompanionTile
                        dashboardData={bffDashboardData}
                        disabled={disableMyChartTiles}
                        isShowAllUsers={isShowAllUsers}
                    />}

                    {(!isProxyUser && isActiveFeature_InsuranceModule) &&
                        <>
                            {enableAALElements
                                ? <AAUserTile isMobile={isMobile} />
                                : (hasHealthPlanLogin || hasFirstCare) &&
                                    <HealthPlanTile isMobile={isMobile} />
                            }
                        </>
                    }

                    {!isProxyUser && hasPharmacyFeature &&
                        <PharmacyAllTile />
                    }
                </div>
            </div>
        </DashboardTile>
    </>)
}


const mapStateToProps = (state) => {
    return {
        bffDashboardData: state.dashboard.bffDashboardData,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        isProxyUser: state.domain.ip,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu)
    }
}

export default withRouter(connect(mapStateToProps, null)(ResourceTile));